import { setActiveTab, setPendingDraft } from '../slices/agent-orchestrator-slice'
import type { AppDispatch } from '../store'

/**
 * Focus the pending new-chat tab and prefill its composer with `value`.
 * Replaces the pre-AXI-3530 `setAgentOrchestratorDraft` flow used by the
 * config-creation pages' "Create with AI" affordances — without the
 * `setActiveTab(null)` companion the prefilled prompt would land on
 * `pendingDraft` while the user is looking at a different active tab,
 * so the toast "Prompt drafted in chat sidebar" wouldn't match what's
 * actually visible. Switching focus to pending makes the draft
 * immediately visible in the composer.
 */
export function prefillNewConversationDraft(value: string) {
  return (dispatch: AppDispatch): void => {
    dispatch(setActiveTab({ id: null }))
    dispatch(setPendingDraft(value))
  }
}
